import Box from '@totallymoney/ui/components/Box'
import Text from '@totallymoney/ui/components/Text'
import theme from '@totallymoney/ui/theme'

interface BannerOfferProps {
    backgroundColor: string
    description: string
    title: string
}

const BannerOffer = ({
    title,
    description,
    backgroundColor,
}: BannerOfferProps) => (
    <Box
        borderTopLeftRadius="borderRadius20"
        borderTopRightRadius="borderRadius20"
        display="flex"
        flexWrap="wrap"
        px="space20"
        pt="space10"
        pb="space30"
        backgroundColor={backgroundColor}
    >
        <Box flex={1}>
            <Text
                variant="80"
                weight="bold"
                style={{ fontFamily: theme.buenosAires }}
                color="dark"
            >
                {title}
            </Text>

            <Text variant="80" color="light">
                {description}
            </Text>
        </Box>
    </Box>
)

export default BannerOffer
